module.exports = __webpack_public_path__ + "static/media/Speed_to_Market.57d782f8.png";